import { render, staticRenderFns } from "./StudentSubmissions.vue?vue&type=template&id=d78a30f6&scoped=true&"
import script from "./StudentSubmissions.vue?vue&type=script&lang=js&"
export * from "./StudentSubmissions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d78a30f6",
  null
  
)

export default component.exports